import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, OccConfig, provideConfig, UrlModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { UigCartSharedModule } from '../uig-cart/uig-cart-shared/uig-cart-shared.module';
import { UigLegalModule } from '../uig-legal/uig-legal.module';
import { UigCheckoutOrderSummaryComponent } from './uig-checkout-order-summary/uig-checkout-order-summary.component';
import { UigCheckoutAdapter } from './uig-checkout.adapter';
import './uig-checkout.models';
import { UigDirectDeliveryComponent } from './uig-direct-delivery/uig-direct-delivery.component';
import { UigOrderConfirmationThankYouMessageComponent } from './uig-order-confirmation-thank-you-message/uig-order-confirmation-thank-you-message.component';
import { UigPlaceOrderComponent } from './uig-place-order/uig-place-order.component';
import { UigReviewSubmitComponent } from './uig-review-submit/uig-review-submit.component';
import {CartSharedModule} from '@spartacus/cart/base/components';
import {CheckoutConfig, CheckoutRootModule, CheckoutStepType} from '@spartacus/checkout/base/root';
import {CartNotEmptyGuard, CheckoutAuthGuard, CheckoutComponentsModule} from '@spartacus/checkout/base/components';
import {CheckoutModule} from "@spartacus/checkout/base";
import { UigVendorOrderSummaryModule } from '../uig-cart/uig-vendor-order-summary/uig-vendor-order-summary.module';

@NgModule({
  declarations: [
    UigPlaceOrderComponent,
    UigCheckoutOrderSummaryComponent,
    UigReviewSubmitComponent,
    UigOrderConfirmationThankYouMessageComponent,
    UigDirectDeliveryComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormsModule,
    FormErrorsModule,
    ReactiveFormsModule,
    CartSharedModule,
    UigCartSharedModule,
    UigLegalModule,
    CheckoutRootModule,
    CheckoutComponentsModule,
    CheckoutModule,
    UigVendorOrderSummaryModule,
    ConfigModule.withConfig({
      backend: {
        occ: {
          endpoints: {
            placeOrder: 'uigUsers/${userId}/orders?fields=FULL',
            checkoutData: 'uigUsers/${userId}/checkoutData',
          },
        },
      },
    } as OccConfig)
  ],
  providers: [
    {
      provide: UigCheckoutAdapter,
      useClass: UigCheckoutAdapter,
    },
    provideConfig({
      checkout: {
        steps: [
          {
            id: 'reviewOrder',
            name: 'checkoutProgress.reviewOrder',
            routeName: 'checkoutReviewOrder',
            type: [CheckoutStepType.REVIEW_ORDER],
          }
        ]
      }
    } as CheckoutConfig), provideConfig({
      cmsComponents: {
        CheckoutReviewOrder: {
          component: UigReviewSubmitComponent,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard],
        },
        CheckoutOrderSummary: {
          component: UigCheckoutOrderSummaryComponent,
        },
        CheckoutPlaceOrder: {
          component: UigPlaceOrderComponent,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard],
        },
        OrderConfirmationThankMessageComponent: {
          component: UigOrderConfirmationThankYouMessageComponent,
          guards: [],
        }
      }
    } as CmsConfig)]
})
export class UigCheckoutModule { }
